"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

var _Card = _interopRequireDefault(require("./Card.styles"));

var _excluded = ["className", "children"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Card = /*#__PURE__*/(0, _react.forwardRef)(function Card(_ref, ref) {
  var className = _ref.className,
      children = _ref.children,
      restOfProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var classes = (0, _Card.default)();
  return /*#__PURE__*/_react.default.createElement("div", Object.assign({}, restOfProps, {
    className: (0, _classnames.default)('pds-card', classes.root, className),
    ref: ref
  }), children);
});
Card.propTypes = {
  /**
   * The content of the component.
   */
  children: _propTypes.node,

  /**
   * The CSS class name to apply to the card node.
   */
  className: _propTypes.string
};
var _default = Card;
exports.default = _default;
